<div class="modal-header">
    <h4 class="modal-title">Delivery Case</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="card-body" [formGroup]="deliveryForm">
        <div class="row">
            <!-- Place of Delivery -->
            <div class="col-xl-3 mb-2">
                <label>Place of Delivery</label>
                <select class="form-control form-control-sm" formControlName="delivery_place_id">
                    <option value=null>Select</option>
                    <option *ngFor="let opt of deliveryplaceList" [value]="opt.id">{{ opt.name }}</option>
                </select>
            </div>

            <!-- Type of Delivery -->
            <div class="col-xl-3 mb-2">
                <label>Type of Delivery</label>
                <select class="form-control form-control-sm" formControlName="delivery_type_id">
                    <option value=null>Select</option>
                    <option *ngFor="let opt of typeofDeliveryList" [value]="opt.id">{{ opt.name }}</option>
                </select>
            </div>

            <!-- Outcome -->
            <div class="col-xl-3 mb-2">
                <label>Outcome</label>
                <select class="form-control form-control-sm" formControlName="outcome_id" (click)="isOtherSelected($event.target.value)">
                    <option value=null>Select</option>
                    <option *ngFor="let opt of outcomeList" [value]="opt.id">{{ opt.name }}</option>
                </select>
                
            </div>
             <div class="col-xl-3 mb-2" *ngIf="enableOtheroutcome">
                <label> Other Outcome</label>
                  <input class="form-control form-control-sm" formControlName="if_others_outcome" placeholder="Enter other outcome">
             </div>

            <!-- Complications -->
            <div class="col-xl-3 mb-2">
                <label>Complications</label>
                <select class="form-control form-control-sm" formControlName="complications_id" (click)="isOtherSelectedcom($event.target.value)">
                    <option value=null>Select</option>
                    <option *ngFor="let opt of complicationsList" [value]="opt.id">{{ opt.name }}</option>
                </select>
            </div>
            <div class="col-xl-3 mb-2" *ngIf="enableOthercomplication">
                 <label> Other Complications</label>
                  <input class="form-control form-control-sm" formControlName="if_others_complications" placeholder="Enter other complication">
             </div>
            <!--<div class="col-xl-3 mb-2">
                <label>Referred To</label>
                <select class="form-control form-control-sm" formControlName="consult_refer_to_id">
                  <option value=null>Select</option>
                   <option *ngFor="let opt of referredist" [value]="opt.id">{{ opt.name }}</option>

                </select>
            </div> -->

        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" id="saveButton" class="btn btn-primary btn-sm" (click)="onSave()">Save</button>

    <button type="button" id="closeButton" class="btn btn-outline-dark btn-sm"
        (click)="activeModal.close('Close click')">Close</button>
</div>